<template>
  <div class="flex items-center">
    <div
      :class="[
        'dashboard-title',
        `dashboard-title--${variant}`,
      ]"
    >
      <div class="dashboard-title__inner">
        <vue-feather
          :type="icon"
          :size="iconSize"
          :class="[
            'dashboard-title__icon',
            `dashboard-title__icon--${variant}`,
          ]"
        />
        <h3
          :class="[
            'dashboard-title__text',
            `dashboard-title__text--${size}`,
            truncate ? 'truncate max-w-xs' : '',
          ]"
          :title="truncate ? title : undefined"
        >
          {{ title }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "calendar",
    },
    iconSize: {
      type: [String, Number],
      default: 16,
    },
    variant: {
      type: String,
      default: "primary", // "primary" or "secondary"
      validator: (value) => ["primary", "secondary"].includes(value),
    },
    size: {
      type: String,
      default: "sm", // "sm" or "base"
      validator: (value) => ["sm", "base"].includes(value),
    },
    truncate: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.dashboard-title {
  background: color-mix(in srgb, var(--hs-bg-soft, #f8fafc) 62%, var(--hs-surface, #ffffff));
  border: 1px solid color-mix(in srgb, var(--hs-border, #e2e8f0) 82%, transparent);
  border-radius: 10px;
  padding: 0.45rem 0.58rem;
}

.dashboard-title--primary {
  background: color-mix(in srgb, var(--hs-primary, #3293ec) 9%, var(--hs-surface, #ffffff));
  border-color: color-mix(in srgb, var(--hs-primary, #3293ec) 20%, var(--hs-border, #e2e8f0));
}

.dashboard-title__inner {
  align-items: center;
  display: flex;
  gap: 0.48rem;
  min-width: 0;
}

.dashboard-title__icon {
  color: var(--hs-muted, #64748b);
  flex-shrink: 0;
}

.dashboard-title__icon--primary {
  color: var(--hs-primary, #3293ec);
}

.dashboard-title__text {
  color: var(--hs-text, #0f172a);
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 0;
}

.dashboard-title__text--sm {
  font-size: 0.86rem;
}

.dashboard-title__text--base {
  font-size: 0.95rem;
}
</style>
